import { useContext } from "react";
import { Text } from "@aidron/aidron-ds";

import PropTypes from 'prop-types';
import { TenantContext } from "../../../templates/context/TenantContext";
import { DEFAULT_VALUES } from "../../components.constants";

export function BodyCell({ prediction }) {

  const { unit } = useContext(TenantContext);

  const language = localStorage.getItem("i18nextLng") || "pt-BR";
  const prefix = unit === "items" ? "" : "R$ ";

  const value = typeof prediction === "string" ? Number(prediction) : prediction;

  return (
    <Text className={unit === "items" ? "text-center" : ""}>
      {!isNaN(value) && value !== null ? prefix + Math.ceil(value).toLocaleString(language) : DEFAULT_VALUES.NOT_APPLY}
    </Text>
  );
}

BodyCell.propTypes = {
  prediction: PropTypes.number,
}
